import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { AuthDialogData } from './auth-dialog-data';
import { SignOut } from './core/auth.actions';

@Component({
    template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <p [innerHTML]="'error.auth.signInFailure.message' | translate:{errMsg: data.message}"></p>
    </div>
    <div mat-dialog-actions align="end">
      <button color="primary" mat-raised-button (click)="onOk()" type="button">{{ data.okText }}</button>
    </div>
  `,
    styles: [`.cdk-overlay-container .mat-mdc-dialog-container { padding: 24px; }`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AuthSignInFailureDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AuthDialogData,
    public dialogRef: MatDialogRef<AuthSignInFailureDialogComponent>,
    private store: Store,
  ) { }

  ngOnInit() { }

  onOk() {
    this.store.dispatch(new SignOut());
    this.dialogRef.close(false);
  }
}
